import { call, put, select, takeEvery } from 'redux-saga/effects';
import * as selectors from '../../../selectors';
import VoucherServices from '../../../services/voucherServices';
import * as actions from '../../actions';
import * as actionTypes from '../../actionTypes/ActionTypes';
import voucherServicesV2 from '../../../services/v2/voucherServicesV2';

// Constants for default and initial states
const DEFAULT_STATISTIC_DATA = { statis: Array(13).fill(0) };
const DEFAULT_VOUCHER_DATA = { total: 0, rows: [] };

export default function* fetchVoucherDataSaga() {
  yield takeEvery(actionTypes.VOUCHER.FETCH_VOUCHER_DATA_REQUEST, fetchVoucherData);
}

export function* fetchVoucherData(action) {
  try {
    const company = yield select(selectors.company);
    const { CompanyId: companyId } = company;

    if (!companyId) {
      yield put(actions.fetchVoucherDataFail('Company ID is missing'));
      return;
    }

    const voucherYears = yield select(selectors.voucherYears);
    let years = voucherYears;
    if (voucherYears?.length === 0) {
      const yearsResponse = yield call(VoucherServices.getYears, companyId);

      if (!yearsResponse?.success) {
        yield put(actions.fetchVoucherDataFail('Failed to fetch years data'));
        return;
      }

      yield put(actions.setVoucherYears(yearsResponse.data));
      years = yearsResponse.data;
    }

    const sfilter = yield select(selectors.filterVoucher);
    const filter = { ...sfilter, companyId };

    // on case exist local year for this company => use as priority
    const storedYear = localStorage.getItem(`voucherYear_${companyId}`);
    const localYear = storedYear !== null ? Number(storedYear) : null;
    const isValidYear = localYear !== null && Number.isFinite(localYear) && years.some((e) => e.value === localYear);

    if (action.payload?.isInit) {
      filter.year = isValidYear ? localYear : (filter.year === null ? years[0]?.value : filter.year || null);
    }

    let voucherData = {
      voucherStatisticData: DEFAULT_STATISTIC_DATA,
      voucherListData: DEFAULT_VOUCHER_DATA
    }

    if (filter?.notRenewStatistic) {
      const voucherStatisticData = yield select(selectors.voucherStatisticDataDefault);
      voucherData.voucherStatisticData = voucherStatisticData || DEFAULT_STATISTIC_DATA;
    } else {
      const voucherStatisticDataResponse = yield call(VoucherServices.getStatistic, filter);
      if (voucherStatisticDataResponse.success) {
        voucherData.voucherStatisticData = voucherStatisticDataResponse.data;
      }
    }
    // fetch vouchers

    const voucherListRes = yield call(voucherServicesV2.fetchAll, { ...filter, withCountPayment: 1 });

    if (voucherListRes?.success) {
      voucherData.voucherListData = voucherListRes.data;
    }
    yield put(actions.fetchVoucherDataSuccess(voucherData));
    yield put(actions.setFilterVoucher({ ...filter, notRenewStatistic: false }));
  } catch (error) {
    console.error(error);
    yield put(actions.fetchVoucherDataFail(error));
  }
}
